import { createSlice } from "@reduxjs/toolkit";

const teacherSlice = createSlice({
  name: "teacher",
  initialState: {
    myClasses: [],
    classesRequest: [],
    classesRequestWA: [],
    classConfirm: null,
    classCancel: null,
    itemDetail: null,
    totalPages: 0,
    totalFound: 0,
  },
  reducers: {
    setMyClasses(state, { payload }) {
      state.myClasses = payload;
    },
    setClassesRequest(state, { payload }) {
      state.classesRequest = payload;
    },
    setClassesRequestWA(state, { payload }) {
      state.classesRequestWA = payload;
    },
    setClassConfirm(state, { payload }) {
      state.classConfirm = payload;
    },
    setClassCancel(state, { payload }) {
      state.classCancel = payload;
    },
    setItemDetail(state, { payload }) {
      state.itemDetail = payload;
    },
    setTotalPages(state, { payload }) {
      state.totalPages = payload;
    },
    setTotalFound(state, { payload }) {
      state.totalFound = payload;
    },
    clearStateTeacher(state) {
      state.myClasses = [];
      state.classesRequest = [];
      state.classConfirm = null;
      state.classCancel = null;
      state.demoClasses = [];
      state.itemDetail = null;
    },
  },
});

export const {
  setMyClasses,
  setClassesRequest,
  setClassConfirm,
  setClassCancel,
  setItemDetail,
  clearStateTeacher,
  setTotalPages,
  setTotalFound,
  setClassesRequestWA,
} = teacherSlice.actions;

export default teacherSlice.reducer;
